import React from "react";
// import './styles.css';
import Lottie from "lottie-react";
import animationData from "./design.json";

const Design = () => (
    <Lottie animationData={animationData} loop={true} style={{ height: "300px" }} />
);
export default Design;
